export default __webpack_public_path__ + "static/media/both.ca0a3965.png";